import React from 'react';
import { Box, Heading, Text, Button, Link } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import TwoColumns from './TwoColumns';

interface GetInTouchProps {
  buttonText: string;
  ctaLink: string;
}

const GetInTouchSection = ({ buttonText, ctaLink }: GetInTouchProps) => (
  <TwoColumns
    col1={
      <StaticImage
        style={{ borderRadius: '8px' }}
        src="../../images/shutterstock_1630960618-Production-2.jpeg"
        alt="Man on phone"
      />
    }
    col2={
      <Box>
        <Heading>Get in Touch</Heading>
        <Text my="9">
          Learn more about how our Transform Plan can help your business.
        </Text>
        <Link href={ctaLink}>
          <Button size="lg">{buttonText}</Button>
        </Link>
      </Box>
    }
  />
);

export default GetInTouchSection;
